import { IIndicator, IInsight, IInsightDialog } from '@jumpstart/core';
import { GraphQLClient } from 'graphql-request';
import { GRAPH_CMS_API } from '../../services/graph-cms/utils';

export const GRAPH_CMS_TOKEN = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImdjbXMtbWFpbi1wcm9kdWN0aW9uIn0.eyJ2ZXJzaW9uIjozLCJpYXQiOjE2MzI4Mzk2OTcsImF1ZCI6WyJodHRwczovL2FwaS11cy13ZXN0LTIuZ3JhcGhjbXMuY29tL3YyL2NrbXFpaGZtdzZyOHMwMXoyMzdscjIxbmMvbWFzdGVyIiwiaHR0cHM6Ly9tYW5hZ2VtZW50LW5leHQuZ3JhcGhjbXMuY29tIl0sImlzcyI6Imh0dHBzOi8vbWFuYWdlbWVudC5ncmFwaGNtcy5jb20vIiwic3ViIjoiODlhYmQ5ZGEtYTMxYy00NGZjLTkwZTMtZjM0YmI4NGNjMjJhIiwianRpIjoiY2t1NDZsaTJsMDlmbDAxeXplcHg4Z205NiJ9.q1zQAY_OF3AsyAaJ8LHKhcFEaaV7TM3ngTErPDVlT_ULiV1eAVWxCrNjo4zeJWQ_HS7pLOOXvvM8aQimw_LqZQ2jWBlJKeV-Z6FHyTwXi-F70n9XcbMQ0xds_RbcxzFhztYr51s-k-5tZ2CHJ_3l1-4isn1kHyD39KHZhp-XsBtlKWIcGetW4sQrCoj84CbBvobTU2KjVCyfXbLjBXz6z109R4dQ27l3VrKo7D9s1320UUcEc7keUps4QKTvAIKEeBYB5vsqWXllwqjNYyk4XzzDGQLmu31IPxLo9AJxvW_-sYIqMAgc79VKqlZAe-juUSFaYuNColZeToWDiBTIgnro-VVPDzRKA5Q4E8gdVqmt63dmdDxyBT9YKDpy1oLoVSBDtc_-l3vXbY6gyUG1FM_Fkz6RQKQhst0uORFefeGSBBLVvBTbO3g-kQXgQeUzLIUb-ZJkIo916b7PGE73pJhCGOanzXbj86NbLNYDIbl2833NLbkeysnIcfDvi7IitBuHw1lp72xhn93qb8EnvZTeSJAbe8miob713fVAJAIOPY1NxiIuzg0ZND4l4f5Q35Qunl5TCWFCdMxMOfIjZ_Z5YE_1zn4Td0zr_lF7_VKo4tAYs6CXgnr4v27aANH1Ik0XzOuNMfrH5SEvTS95oNx5nfY6bEV_PDSNUpQpjDU';
export const graphQLClient = new GraphQLClient(GRAPH_CMS_API, {
  headers: {
    authorization: `Bearer ${GRAPH_CMS_TOKEN}`
  }
});

// const prod = 'http://192.168.1.7:3000';
const prod = 'https://www.scout9-test.com';
const dev = 'http://localhost:3000';

export const uiExternalUrls = {
  home: `${process.env.NODE_ENV === 'production' ? prod : dev}/app/home`,
  indicators: (insight: IInsight) => `${process.env.NODE_ENV === 'production' ? prod : dev}/app/guidance/${insight.id}/indicators`,
  indicator: (
    insight: IInsight,
    indicator: IIndicator
  ) => `${process.env.NODE_ENV === 'production' ? prod : dev}/app/guidance/${insight.id}/indicator/${indicator.id}`,
  dialog: (
    insight: IInsight,
    indicator: IIndicator,
    dialog: IInsightDialog
  ) => `${process.env.NODE_ENV === 'production' ? prod : dev}/app/guidance/${insight.id}/indicator/${indicator.id}/${dialog.id}`,
  loading: `${process.env.NODE_ENV === 'production' ? prod : dev}/loading`
};
